import React from "react";
import Dashboard from "../../components/Dashboard";

const PhysicScheduleNewTest = () => {
  return <Dashboard>PhysicScheduleNewTest</Dashboard>;
};

export default PhysicScheduleNewTest;
